<template>
  <div>
    <div
      class="modal animated fadeIn"
      tabindex="-1"
      id="new-product"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 25px; font-weight: bold"
                  >New product-- {{ Productnumber }}</small
                >
              </legend>
              <form @submit.prevent="newProduct()">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Product name</label>
                      <input
                        type="text"
                        class="form-control product_name input_rounded"
                        placeholder="product name"
                        required
                      />
                    </div>
                    <div class="form-group">
                      <label>Product measurement</label>
                      <select
                        name="product_measurement"
                        class="form-control input_rounded product_measurement"
                      >
                        <option value>Select Measurement</option>
                        <option value="KG">KILOGRAMS</option>
                        <option value="PCS">PIECES</option>
                        <option value="LTS">LITRES</option>
                        <option value="SET">SET</option>
                        <option value="PAIR">PAIR</option>
                        <option value="MTR">METRES</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Product description</label>
                      <textarea
                        class="form-control product_description input_rounded"
                        placeholder="product description"
                      ></textarea>
                    </div>

                    <div class="form-group">
                      <label>Minimum Stock level </label>
                      <input
                        type="number"
                        class="form-control minimum_stock_level"
                        required
                      />
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  class="btn btn-primary btn-flat btn-rounded creatingProduct"
                >
                  <i class="fa fa-plus"></i> create product
                </button>
                <button
                  type="button"
                  class="btn btn-info btn-flat btn-rounded creatingProductLoader"
                >
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i class="fa fa-spinner fa-spin" style="font-size: 24px"></i>
                  please wait...
                </button>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal animated fadeIn"
      tabindex="-1"
      id="new-supplier"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 25px; font-weight: bold"
                  >New Supplier</small
                >
              </legend>
              <form @submit.prevent="newSupplier()">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Supplier name</label>
                      <input
                        type="text"
                        class="form-control supplier_name"
                        placeholder="supplier name"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Contact person</label>
                      <input
                        type="text"
                        class="form-control contact_person"
                        placeholder="contact person"
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Phone number</label>
                      <input
                        type="text"
                        class="form-control phone_number"
                        placeholder="phone number"
                      />
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  class="btn btn-primary btn-flat creatingSupplier btn-rounded"
                >
                  <i class="fa fa-truck"></i> Add Supplier
                </button>
                <button
                  type="button"
                  class="btn btn-primary btn-flat creatingSupplierLoader btn-rounded"
                >
                  <i class="fa fa-spinner fa-spin" style="font-size: 24px"></i
                  >please wait...
                </button>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">Receive Goods</div>
            <fieldset class="border p-2">
              <button
                type="button"
                class="btn btn-primary btn-roundec"
                data-toggle="modal"
                data-target="#new-product"
              >
                <i class="fa fa-plus"></i> new Product
              </button>
              <p></p>
              <button
                type="button"
                class="btn btn-primary btn-roundec"
                data-toggle="modal"
                data-target="#new-supplier"
              >
                <i class="fa fa-plus"></i> new Supplier
              </button>
              <p></p>
              <div></div>
              <div>
                <form @submit.prevent="newGrn()">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>
                          Receiving date
                          <span class="text-danger">*</span>
                        </label>
                        <input
                          type="date"
                          class="form-control receiving_date input-rounded f-s-14"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="table-responsive">
                      <table class="table">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">Product/Item</th>
                            <th scope="col">Balance Before</th>
                            <th scope="col">Quantity</th>
                            <th scope="col text-right">Balance After</th>
                            <th scope="col text-right">Unit price</th>
                            <th scope="col text-right">Supplier</th>
                            <th scope="col text-right">Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(invoice_product, k) in goodsitemsRows"
                            :key="k"
                          >
                            <td scope="row">
                              <button
                                type="button"
                                class="btn btn-raised btn-raised-danger btn-sm m-1"
                                @click="deleteRow(k, invoice_product)"
                              >
                              <i class="nav-icon i-Close-Window font-weight-bold"></i>
                              </button>
                              <!-- <i class="fa fa-trash-alt" @click="deleteRow(k, invoice_product)"></i> -->
                            </td>
                            <td>
                              <model-list-select
                                :list="systemProducts"
                                v-model="invoice_product.product_id"
                                option-value="id"
                                :custom-text="productNameandNumber"
                                placeholder="select Product"
                                required
                                @input="getProduct(invoice_product.product_id)"
                              ></model-list-select>
                            </td>
                            <td>
                              <input
                                readonly
                                required
                                class="form-control"
                                id="balance_stock"
                                type="number"
                                v-model="invoice_product.balance_stock"
                              />
                            </td>
                            <td>
                              <input
                                required
                                class="form-control"
                                type="number"
                                id="qty"
                                min="1"
                                step=".01"
                                @wheel="$event.target.blur()"
                                v-model="invoice_product.qty"
                                @keyup="calculateLineTotal(invoice_product)"
                              />
                            </td>
                            <td>
                              <input
                                readonly
                                required
                                class="form-control"
                                id="balance_stock"
                                type="number"
                                v-model="invoice_product.product_measurement"
                              />
                            </td>
                            <td>
                              <input
                                required
                                class="form-control"
                                type="number"
                                min="1"
                                step=".01"
                                @wheel="$event.target.blur()"
                                v-model="invoice_product.unit_price"
                                @keyup="calculateLineTotal(invoice_product)"
                              />
                            </td>

                           <td>
                              <model-list-select
                                :list="systemSuppliers"
                                v-model="invoice_product.supplier_id"
                                option-value="id"
                                option-text="supplier_name"
                                placeholder="select supplier"
                                required
                              ></model-list-select>
                            </td>
                            <td>
                              <input
                                required
                                readonly
                                class="form-control text-right"
                                type="number"
                                min="1"
                                step=".01"
                                v-model="invoice_product.total_price"
                              />
                            </td>
                          </tr>
                          <tr v-show="goodsitemsRows.length === 0">
                            <td colspan="7">
                              <p class="text-center alert-danger p-2">
                                No products added/available.
                              </p>
                            </td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td colspan="7" class="text-right">Sub Total</td>
                            <input
                              required
                              readonly
                              class="form-control text-right sub_total"
                              type="number"
                              min="1"
                              step=".01"
                              :value="invoice_subtotal"
                            />
                          </tr>
                          <tr>
                            <td colspan="7" class="text-right">Total</td>
                            <input
                              required
                              readonly
                              class="form-control text-right goods_grand_total"
                              type="number"
                              min="1"
                              step=".01"
                              :value="invoice_total"
                            />
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                    <div class="clearfix"></div>
                    <div class="col-md-12 mb-2">
                      <button
                        type="button"
                        class="btn btn-info"
                        @click="addGoodsItems"
                      >
                        <i class="fa fa-plus-circle"></i>
                        Add
                      </button>
                    </div>
                    <div class="col-md-12 mb-2">
                      <button
                        type="submit"
                        class="btn btn-primary creatingGoodreceiving"
                      >
                        <i class="fa fa-plus"></i> receive goods
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary creatingGoodreceivingLoader"
                      >
                        <span
                          class="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        <i
                          class="fa fa-spinner fa-spin"
                          style="font-size: 24px"
                        ></i>
                        please wait...
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import $ from "jquery";
import router from "../router/index";
import { ModelListSelect } from "vue-search-select";
export default {
  data() {
    return {
      invoice_subtotal: 0,
      invoice_total: 0,
    };
  },
  created() {
    this.loadProduct();
    this.loadProductnumber();
    this.loadSuppliers();
  },
  computed: {
    ...mapGetters([
      "PurchaseItem",
      "goodsitemsRows",
      "systemProducts",
      "Purchaseorderitem",
      "Productnumber",
      "systemSuppliers",
      "getsystemProducts",
    ]),
  },
  methods: {
    ...mapActions([
      "newGrn",
      "loadProduct",
      "loadProductnumber",
      "newProduct",
      "loadSuppliers",
      "getProduct",
      "newSupplier",
    ]),
    ...mapMutations(["addGoodsItems"]),
    productNameandNumber(item) {
      return `${item.product_name} - (${item.product_number})`;
    },

    calculatePrice(invoice_product) {
      var total1 = parseFloat(invoice_product.unit_price) * parseFloat(1.15);
      if (!isNaN(total1)) {
        invoice_product.sell_price = total1.toFixed(2);
      }
    },
    calculateTotal() {
      var subtotal, total, totals;
      subtotal = this.goodsitemsRows.reduce(function (sum, product) {
        var lineTotal = parseFloat(product.total_price);
        if (!isNaN(lineTotal)) {
          return sum + lineTotal;
        }
      }, 0);

      if (!isNaN(subtotal)) {
        this.invoice_subtotal = subtotal.toFixed(2);
      } else {
        this.invoice_subtotal = "0.00";
      }
      total = subtotal;
      total = parseFloat(total);
      if (!isNaN(total)) {
        this.invoice_total = total.toFixed(2);
      } else {
        this.invoice_total = "0.00";
      }
    },
    calculateLineTotal(invoice_product) {
      var total =
        parseFloat(invoice_product.unit_price) *
        parseFloat(invoice_product.qty);
      if (!isNaN(total)) {
        invoice_product.total_price = total.toFixed(2);
      }
      var balance_stock = (invoice_product.balance_stock =
        this.$store.getters.getsystemProducts);
      console.log(balance_stock);
      var total2 =
        parseFloat(invoice_product.balance_stock) +
        parseFloat(invoice_product.qty);
      if (!isNaN(total2)) {
        invoice_product.product_measurement = total2;
      }
      // console.log(total2);
      this.calculateTotal();
      var total1 = parseFloat(invoice_product.unit_price) * parseFloat(1.15);
      if (!isNaN(total1)) {
        invoice_product.sell_price = total1.toFixed(2);
      }
    },

    calculateBalanceTotal(invoice_product) {
      var total2 =
        parseFloat(invoice_product.balance_stock) +
        parseFloat(invoice_product.qty);
      if (!isNaN(total2)) {
        invoice_product.product_measurement = total;
      }
      console.log();
    },
    deleteRow(index, invoice_product) {
      var idx = this.goodsitemsRows.indexOf(invoice_product);
      if (idx > -1) {
        this.goodsitemsRows.splice(idx, 1);
      }
      this.calculateTotal();
    },
  },
  components: {
    ModelListSelect,
  },
};
</script>
<style scoped>
.creatingGoodreceivingLoader {
  display: none;
}

.creatingProductLoader {
  display: none;
}
.creatingSupplierLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/goodsreceiving/updatepurchaseorder.vue